export enum Event {
  onPagination = 'onPagination',
  onOrder = 'onOrder',
  onGlobalSearch = 'onGlobalSearch',
  onSearch = 'onSearch',
  onClick = 'onClick',
  onDoubleClick = 'onDoubleClick',
  onCheckboxSelect = 'onCheckboxSelect',
  onRadioSelect = 'onRadioSelect',
  onSelectAll = 'onSelectAll',
  onColumnResize = 'onColumnResize',
  onRowDrop = 'onRowDrop',
  onReorderStart = 'onReorderStart',
  onRowCollapsedShow = 'onRowCollapsedShow',
  onRowCollapsedHide = 'onRowCollapsedHide',
  onRowContextMenu = 'onRowContextMenu',
  onEnabled = 'onEnabled',
}
